import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

const FileUploader = ({
                          onFilesChange,
                          styles = {},
                          accept = "*",
                          multiple = true,
                      }) => {
    const [files, setFiles] = useState([]);

    const onDrop = useCallback(
        (acceptedFiles) => {
            const newFiles = [...files, ...acceptedFiles];
            setFiles(newFiles);
            if (onFilesChange) onFilesChange(newFiles);
        },
        [files, onFilesChange]
    );

    const removeFile = (fileName) => {
        const updatedFiles = files.filter((file) => file.name !== fileName);
        setFiles(updatedFiles);
        if (onFilesChange) onFilesChange(updatedFiles);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept,
        multiple,
    });

    return (
        <div style={{ maxWidth: 500, margin: "20px auto", ...styles.container }}>
            <div
                {...getRootProps()}
                style={{
                    border: "2px dashed #999",
                    padding: "20px",
                    borderRadius: "8px",
                    backgroundColor: isDragActive ? "#f0f0f0" : "#fff",
                    textAlign: "center",
                    cursor: "pointer",
                    ...styles.dropZone,
                }}
            >
                <input {...getInputProps()} />
                <p>
                    {isDragActive
                        ? "Drop the files here ..."
                        : "Click or drag files to upload"}
                </p>
            </div>

            {files.length > 0 && (
                <div style={{ marginTop: 20, ...styles.fileList }}>
                    <h4>Selected Files:</h4>
                    <ul style={{ paddingLeft: 20 }}>
                        {files.map((file) => (
                            <li key={file.name} style={{ marginBottom: 8 }}>
                                {file.name} ({Math.round(file.size / 1024)} KB)
                                <button
                                    onClick={() => removeFile(file.name)}
                                    style={{
                                        marginLeft: 10,
                                        padding: "2px 6px",
                                        cursor: "pointer",
                                        ...styles.removeButton,
                                    }}
                                >
                                    Remove
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default FileUploader;
